export const RarityRank = {
  TIER_1: 0,
  TIER_2: 1,
  TIER_3: 2,
  TIER_4: 3,
  TIER_5: 4,
  TIER_6: 5,
  E_NUM: 6,
};

export const FESCLASSIC_GACHA_PERCENT_DICT = {
  [RarityRank.TIER_6]: 0.5,
  [RarityRank.TIER_5]: 0.5,
};

export const SPECIAL_GACHA_PERCENT_DICT = {
  [RarityRank.TIER_6]: 1,
  [RarityRank.TIER_5]: 0.6,
};
